<template>
  <div>
    <modal
      name="doctorsAdd"
      title="Add new doctor"
      class="custom-modal"
      height="auto"
      width="600"
    >
      <template v-slot:content>
        <div class="add-lookups mt-1">
          <validation-observer ref="lookups">
            <div>
              <validation-provider rules="required" v-slot="{ errors }">
                <Input
                  label="Name"
                  class="doctor-input mb-base"
                  type="text"
                  :error="errors[0]"
                  v-model="lookups.name"
                />
              </validation-provider>
              <Input
                label="Description"
                class="doctor-input mb-base"
                type="text"
                v-model="lookups.description"
              />
              <validation-provider rules="phoneNumber" v-slot="{ errors }">
                <Input
                  label="Cell Number"
                  class="doctor-input mb-base"
                  type="text"
                  :error="errors[0]"
                  v-model="lookups.cell_no"
                />
              </validation-provider>
              <Button
                title="Save"
                className="button--primary"
                :loader="isLoading"
                :onClick="handleDoctors"
              />
            </div>
          </validation-observer>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Button from "@/components/Button";
import Input from "@/components/Input";
import Modal from "@/components/Modal";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    Button,
    Modal,
    Input
  },
  data() {
    return {
      isLoading: false,
      lookups: {
        type: "doctor"
      }
    };
  },
  methods: {
    ...mapActions("doctors", ["addDoctors", "listRefferedByDoctors"]),
    handleDoctors() {
      this.$refs.lookups.validate().then(success => {
        if (!success) {
          return;
        }
        this.isLoading = true;
        this.addDoctors({
          ...this.lookups,
          isOther: this.isOther
        })
          .then(() => {
            this.lookups = {};
            this.$refs.lookups.reset();
            this.listRefferedByDoctors("doctor").then(() => {
              this.isLoading = false;
              this.$modal.hide("doctorsAdd");
            });
          })
          .catch(() => (this.isLoading = false));
      });
    }
  },
  computed: {
    ...mapGetters({
      role: "auth/role",
      isOther: "auth/isOther",
      loading: "loading"
    }),
    userRole() {
      return this.role && this.role.find(item => item);
    }
  }
};
</script>

<style></style>
